<span  (mouseout)="editingRating = rating" (click)="setRate()">
  <span (mouseover)="rate(1)" class="fa fa-star {{starChecked(1)}}"></span>
  <span (mouseover)="rate(25)" class="fa fa-star {{starChecked(25)}}"></span>
  <span (mouseover)="rate(50)" class="fa fa-star {{starChecked(50)}}"></span>
  <span (mouseover)="rate(75)" class="fa fa-star {{starChecked(75)}} "></span>
  <span (mouseover)="rate(100)" class="fa fa-star {{starChecked(100)}}"></span>
  </span>